const instruments = {
    data() {
        return {
            instruments: {
                harmonic: {
                    Guitar: { name: 'Acoustic Guitar (nylon)' },
                    Piano: { name: 'Acoustic Grand Piano' },
                    Marimba: { name: 'Marimba' },
                    Kalimba: { name: 'Kalimba' },
                    Vibraphone: { name: 'Vibraphone' },
                    Pan: { name: 'Pan Flute' },
                    Flute: { name: 'Flute' },
                    Bagpipe: { name: 'Bagpipe' },
                    Piffero: { name: 'Oboe' },
                    Accordion: { name: 'Accordion' },
                },
                percussion: {
                    Bongo: { name: 'Low Bongo', note: 61, velocity: 0.8 },
                    Conga: { name: 'Low Conga', note: 64, velocity: 0.8 },
                    Maracas: { name: 'Maracas', note: 70, velocity: 0.5 },
                    Tambourine: { name: 'Tambourine', note: 54, velocity: 0.5 },
                    Castanets: { name: 'Castanets', note: 75, velocity: 0.5 },
                    Cowbells: { name: 'Cowbell', note: 56, velocity: 0.5 },
                    Triangle: { name: 'Open Triangle', note: 81, velocity: 0.5 },
                    Cabasa: { name: 'Cabasa', note: 69, velocity: 0.5 },
                    Clap: { name: 'Hand Clap', note: 39, velocity: 0.5 },
                    Bass: { name: 'Bass Drum 1', note: 36, velocity: 0.6 },
                    Snare: { name: 'Acoustic Snare', note: 38, velocity: 0.5 },
                    Woodblock: { name: 'Hi Wood Block', note: 76, velocity: 0.7 },
                }
            }
        }
    }
}

export default instruments;